import React, { useState } from "react";
import { Notification, useLogin, useNotify } from "react-admin";
import { ThemeProvider } from "@material-ui/styles";
import { Avatar, Card, Grid } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import { SERVER_DOMAIN } from "../constants";
import { PhoneValidate } from "../utils/validation";

const _LoginPage = ({ theme }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [btnText, setBtnText] = useState("درخواست کد");
  const [codeDisplay, setCodeDisplay] = useState("none")
  const login = useLogin();
  const notify = useNotify();
  const sendCode = (e) => {
    console.log("sending code")
    axios
      .post(`${SERVER_DOMAIN}/requestCode`, {
        phoneNumber: phoneNumber,
      })
      .then((res) => {
        console.log("send  code res", res)

        if (res.status < 200 || res.status >= 300) {
          throw new Error(res.statusText);
        } else {
          setBtnText("تایید و ورود");
          setLoading(false);
          notify("Mozaffari.general.send_code", "info");
          setCodeDisplay("")
        }
      })
      .catch((err) => {
        setLoading(false);
        notify("Mozaffari.general.generic_err", "warning");
      });
  }
  const submit = (e) => {
    e.preventDefault();
    if (PhoneValidate(phoneNumber).valid) {
      setLoading(true);
      if (btnText === "درخواست کد") {
        axios
          .post(`${SERVER_DOMAIN}/requestCode`, {
            phoneNumber: phoneNumber,
            panel: 'hrpanel',
          })
          .then((res) => {
            if (res.status < 200 || res.status >= 300) {
              throw new Error(res.statusText);
            } else {
              setBtnText("تایید و ورود");
              setLoading(false);
              notify("Mozaffari.general.send_code", "info");
              setCodeDisplay("")
            }
          })
          .catch((err) => {
            setLoading(false);
            notify("Mozaffari.general.call_manager", "warning");

          });
      } else {
        login({ username: phoneNumber, password: code }).catch(() => {
          setLoading(false);
          notify("ra.auth.sign_in_error", "warning");
        });
      }
    } else {
      // setInvalidPhone(true);
      notify("Mozaffari.general.invalid_phone_number", "warning");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          alignItems: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          // background: `url(${bg}), linear-gradient(to top, #37ecba 0%, #72afd3 100%)`,
        }}
      >
        <Card
          style={{
            minWidth: 400,
            margin: "8em",
            padding: "1em 1em 0 1em",
            minHeight: 400,
            background: "rgba( 255, 255, 255, 0.4 )",
            boxShadow: "0 8px 32px 0 rgba( 31, 38, 135, 0.37 )",
            backdropFilter: "blur( 4.0px )",
            WebkitBackdropFilter: "blur( 4.0px )",
            borderRadius: "10px",
            border: "1px solid rgba( 255, 255, 255, 0.18 )",
          }}
          elevation={5}
        >
          <div
            style={{
              margin: "1em",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar
              style={{
                backgroundColor: theme.palette.secondary[500],
                width: 80,
                height: 80,
                marginTop: 10,
              }}
              src="logo.png"
            />
          </div>
          <Typography
            style={{ textAlign: "center", marginBottom: "0.8em" }}
            variant="h6"
          >
            همکاران / بخش مالی و انسانی
          </Typography>
          <form
            onSubmit={submit}
            style={{
              padding: "0 1em 1em 1em",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <TextField
              disabled={btnText === "تایید و ورود"}
              style={{ margin: "0 0 0.5em 0" }}
              name="phone"
              label="شماره تلفن"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              variant="outlined"
            />
            <TextField
              style={{ margin: "0.5em 0" }}
              name="code"
              label="کد تایید"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              variant="outlined"
              disabled={btnText === "درخواست کد"}
            />
            <Grid container spacing={2} >
              <Grid item xs={8}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{ margin: "1em 0", padding: "0.8em 0", width: "100%" }}
                >
                  {loading ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    btnText
                  )}
                </Button>
              </Grid>
              <Grid item xs={4}>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => sendCode(e.target.value)}
                  size="large"
                  style={{ margin: "1em 0", padding: "0.8em 0", display: codeDisplay, width: "100%" }}
                >

                  ارسال مجدد کد
                </Button>
              </Grid>

            </Grid>
          </form>
        </Card>
      </div>
      {/* </div> */}
      <Notification />
    </ThemeProvider>
  );
};

export default _LoginPage;
